import React from 'react';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import useCurrentTextStyle from '../../../../hooks/useCurrentTextStyle';

export const ProductTitle = ({ product, isMobile, settings, globals, onTitleClick }) => {
  const { getCurrentTextStyle } = useCurrentTextStyle();

  const {
    title_style,
    title_style_mobile,
    title_style_tablet,
    title_style_ultrawide,
    title_style_enable_responsive,
    title_alignment = 'left',
    padding_top = 0,
    padding_right = 0,
    padding_bottom = 0,
    padding_left = 0,
    margin_top = 0,
    margin_right = 0,
    margin_bottom = 0,
    margin_left = 0
  } = settings;



  if (!product?.title) return null;

  const handleClick = () => {
    if (onTitleClick) {
      onTitleClick({ action: 'title_click' });
    }
  };

  return (
    <div 
      className={`
        text-${title_alignment}
        pt-[${padding_top}px]
        pb-[${padding_bottom}px]
        pl-[${padding_left}px]
        pr-[${padding_right}px]
        mt-[${margin_top}px]
        mb-[${margin_bottom}px]
        ml-[${margin_left}px]
        mr-[${margin_right}px]
      `}
      onClick={handleClick}
    >
      <a
        href={'/products/' + product?.handle}
        onTouchEnd={() => {window.location.href = '/products/' + product?.handle;}}
      >
        <h2 className={getCurrentTextStyle(title_style, title_style_enable_responsive, title_style_mobile, title_style_tablet, title_style_ultrawide) || 'b1'}>{product?.title}</h2>
      </a>
    </div>
  );
};